export var MAX_PURCHASE_QUANTITY = 100;
export var MUST_BE_IN_APP_MESSAGE_WARNING = "inAppMessage must be an InAppMessage object";
export var MUST_BE_CARD_WARNING_SUFFIX = "must be a Card object";
export var FEED_ANIMATION_DURATION = 500;
export var LOG_CUSTOM_EVENT_STRING = "logCustomEvent";
export var SET_CUSTOM_USER_ATTRIBUTE_STRING = "setCustomUserAttribute";
export var BRAZE_MUST_BE_INITIALIZED_ERROR = "Braze must be initialized before calling methods.";
export var GLOBAL_RATE_LIMIT_CAPACITY_DEFAULT = 30;
export var GLOBAL_RATE_LIMIT_REFILL_RATE_DEFAULT = 30;
export var LAST_REQUEST_TO_ENDPOINT_MS_AGO_DEFAULT = 72e5;
export var MAX_RETRY_COUNT_PER_REQUEST = 15;
export var REQUEST_ATTEMPT_DEFAULT = 1;
export var SUBSCRIPTION_ID_DATA_ATTRIBUTE = "data-update-subscription-id";
export var BANNERS_DISABLED_MESSAGE = "Banners are disabled. Make sure you have at least one campaign and relaunch the app.";